import { Outlet } from 'react-router';

import { AppLayout } from 'AppLayout';

export const NotRequireAuth = () => (
  <AppLayout isForLogged={false}>
    <Outlet />
  </AppLayout>
);
